export const SET_SHOW_CHARTS = 'showCharts';
export const SET_DATE = 'dateSelection';
export const SET_EMPRESA = 'empresa';
export const SET_CENTRO_CUSTO = 'centroCusto';
export const SET_PRODUTO = 'produto';
export const SET_PROJETO = 'projeto';
export const SET_RESPONSAVEL = 'responsavel';
export const SET_TIPO_PRODUTO = 'tipoProduto';
